import React from 'react';
import useEventListener from 'hooks/use-event-listener';

export default function useIsKeyPressed(keyCode: string | number): boolean {
  const [isPressed, setIsPressed] = React.useState<boolean>(false);

  useEventListener('keydown', onKeyDown);
  useEventListener('keyup', onKeyUp);

  function onKeyDown(event) {
    if (event.keyCode === keyCode) {
      setIsPressed(true);
    }
  }

  function onKeyUp(event) {
    if (event.keyCode === keyCode) {
      setIsPressed(false);
    }
  }

  return isPressed;
}
